<template>
    <div class="fileupload">
        <div class="custom-file b-form-file d-inline-block">
            <input :multiple="multiple" v-on:change="change($event.target.name, $event.target.files)" class="custom-file-input" type="file">
            <span class="custom-file-label">{{chooseLabel}}</span>
        </div>
        <div class="progress mt-2" v-if="uploadProgressNumber > 0"> 
            <div class="progress-bar progress-bar-striped" role="progressbar" :style="`width: ${uploadProgressNumber}%`" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div v-if="initvalue.length > 0">
            <template v-for="item in initvalue">
                <div>
                    <div class="img_wrp">
                        <img class="d-inline-block mt-2" style="max-width: 100px; vertical-align: middle;" v-bind:src="showImage(item)">
                        <span class="badge badge-light close" @click="removeImage(item)"><icon icon='times'></icon></span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>

export default
{
    name: 'FileUpload',
    props: ['value', 'multiple', 'chooseLabel'],
    data: function()
    {
        return {
            uploadedImageData: '',
            uploadProgressNumber: 0,
            initvalue: []
        };
    },
    created: function()
    {
        var me = this;
        if (me.value != null)
        {
            me.initvalue = me.value.split(',');
        }
    },
    methods:
    {
        showImage(val)
        {
            return val.substring(1);
        },
        change(fieldName, fileList)
        {
            const me = this;
            if (!fileList.length) return;

            for (let file of fileList)
            {
                const reader = new FileReader();
                reader.addEventListener('loadend', (event) =>
                {
                    const formdata = new FormData();

                    formdata.append('fileName', file.name);
                    formdata.append('file', event.target.result);
                    const request = new XMLHttpRequest();

                    me.uploadProgressNumber = 0;
                    request.upload.addEventListener("progress", (evt) =>
                    {
                        if (evt.loaded <= file.size) {
                            me.uploadProgressNumber = Math.round(evt.loaded / file.size * 100);
                        } 

                        if (evt.loaded === evt.total)
                        {
                            me.uploadProgressNumber = 100;

                            setTimeout(() =>
                            {
                                me.uploadProgressNumber = 0;
                            }, 1500);
                        }
                    });

                    request.addEventListener("load", (evt) => {
                    
                        try
                        {
                            const response = JSON.parse(request.response);

                            if (response.error === false)
                            {
                                me.initvalue.push(response.path);
                            }
                        }
                        catch (e)
                        {
                            console.log(e);
                        }
                    });
                    request.addEventListener("error", (evt) => {
                        console.log('error', evt);
                    });
                    request.addEventListener("abort", (evt) => {
                        console.log('abort', evt);
                    });

                    request.open('post', '/Upload/uploadFile');
                    request.timeout = 45000;
                    request.send(formdata); 
                });
                reader.readAsDataURL(file);
            }

            me.$emit('input', me.initvalue);
        },
        removeImage(imgSrc)
        {
            const me = this;
            me.$store.commit('setModalAlert', {
            text: me.$i18n.t('AREYOUSHURETOREMOVETHEIMAGE'),
            async btnAction() {
                
                const formdata = new FormData();
                formdata.append('imgSrc', imgSrc);
                const request = new XMLHttpRequest();
                request.addEventListener("load", (evt) => {
                    try
                    {
                        if (me.initvalue.indexOf(imgSrc) !== -1)
                        {
                            me.initvalue.splice(me.initvalue.indexOf(imgSrc), 1);
                            me.$emit('input', me.initvalue);
                        }
                    }
                    catch (e)
                    {
                        console.log(e);
                    }
                });
                request.open('post', '/Upload/removeImage');
                request.send(formdata);

                
            }, 
            });
        }
    },
    watch:
    {
        
    },
    computed:
    {
        
    }
}
</script>

<style lang="css" scoped>

.img_wrp {
  display: inline-block;
  position: relative;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

</style>